import { z } from 'zod'
import { NOTIFICATION_TYPES } from '../constants/training-enums'

export const CreateNotificationTemplateSchema = z.object({
  notificationType: z.enum(NOTIFICATION_TYPES, { message: '通知タイプを選択してください。' }),
  subject: z
    .string()
    .min(1, { message: '件名を入力してください。' })
    .max(500, { message: '件名は500文字以内で入力してください。' }),
  body: z
    .string()
    .min(1, { message: '本文を入力してください。' })
    .max(10000, { message: '本文は10000文字以内で入力してください。' }),
  // 変数を使わない通知（reminder_survey 等）があるため空配列を許容する
  availableVariables: z.array(z.string()),
})

export const UpdateNotificationTemplateSchema = CreateNotificationTemplateSchema.pick({
  subject: true,
  body: true,
  availableVariables: true,
}).partial()

export type CreateNotificationTemplateInput = z.infer<typeof CreateNotificationTemplateSchema>
export type UpdateNotificationTemplateInput = z.infer<typeof UpdateNotificationTemplateSchema>
